/**
 * Группа техники — пользовательская папка внутри компании (участок, объект,
 * бригада). Одна машина принадлежит максимум одной группе, поэтому у строки
 * техники есть group_id, а не массив групп.
 */
export interface IMachineryGroup {
    id: string;
    company_id: string;
    name: string;
    created_at: string;
    updated_at: string;
    /** Сколько машин сейчас в группе — считает бэкенд, фронт только показывает. */
    machinery_count: number;
    /**
     * Токен гостевой ссылки. null — доступ по ссылке не выдан.
     * Приходит только в кабинетных ответах (эндпоинт под авторизацией).
     */
    share_token: string | null;
    /** Когда ссылка выпущена, ISO-строка. null — ссылки нет. */
    share_created_at: string | null;
}

/**
 * Область отчёта «Без группы» — вся техника компании, не входящая ни в одну
 * группу. Совпадает с литералом на бэкенде (UNGROUPED_SCOPE_ID).
 *
 * Существует, чтобы компаниям, которые группами не пользуются, не приходилось
 * заводить фиктивную группу ради отчёта.
 */
export const UNGROUPED_SCOPE_ID = "ungrouped";

/** Полный URL гостевой страницы по токену — строится от текущего origin. */
export const buildShareUrl = (token: string): string =>
    `${window.location.origin}/share/group/${token}`;

/**
 * Значение фильтра таблицы по группе.
 *   null              — все машины;
 *   NO_GROUP_FILTER   — только машины без группы;
 *   string (uuid)     — конкретная группа.
 *
 * Отдельная константа вместо "" нужна, чтобы «без группы» нельзя было
 * спутать с «фильтр не выбран»: это два разных состояния таблицы.
 */
export const NO_GROUP_FILTER = "__none__";

export type MachineryGroupFilter = string | null;
